const serverStatsApiUrl = 'https://api.guildguardian.de/v2/server-stats'

export async function fetchServerStats() {
  const response = await fetch(serverStatsApiUrl)

  if (!response.ok) {
    throw new Error(`Server stats failed with status ${response.status}`)
  }

  const data = await response.json()

  return Array.isArray(data) ? data : []
}
